import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=d703f834"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports